import React from 'react';
import { Route } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

import { RoutePathProps } from '../../../AppRoutes/types';
import PartiesList from '../pages/party/PartiesList';
import PartyDetails from '../pages/party/PartyDetails';
import AddEditParty from '../pages/party/AddEditParty';
import DailyLedgerList from '../pages/dailyLedger/DailyLedgerList';
import AddEditLedgerSlip from '../pages/dailyLedger/AddEditDailyLedger';


// import EditProduct from '../pages/EditProduct';

const parties: RoutePathProps = {
  name: "parties",
  path: "/parties",
  label: "Parties",
  icon: GroupIcon,
  visibleInNav: true,
  requiredPermission:'party:list',
  children: [
    {
      name: "partyDetails",
      path: "/parties/:id",
      label: "Party Details",
      icon: GroupIcon,
      requiredPermission:'party:read'
    },
    {
      name: "addParty",
      path: "/parties/addParty",
      label: "Add Party",
      icon: GroupIcon,
      requiredPermission:'party:create'
    },
    {
      name: "editParty",
      path: "/parties/editParty/:id",
      label: "Edit Party",
      icon: GroupIcon,
      requiredPermission:'party:update'
    },
    {
      name: "dailyLedger",
      path: "/parties/dailyLedger/:partyId",
      label: "Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:read'
    },
    {
      name: "addDailyLedger",
      path: "/parties/dailyLedger/addDailyLedger/:partyId",
      label: "Add Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:create'
    },
    {
      name: "editDailyLedger",
      path: "/parties/dailyLedger/editDailyLedger/:partyId/:ledgerId",
      label: "Edit Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:update'
    },
  ],
};

const PartiesRoutes = (
  <>
    <Route path={parties.path} element={<PartiesList />} />
    <Route path={parties.children?.[0].path} element={<PartyDetails />} />
    <Route path={parties.children?.[1].path} element={<AddEditParty />} />
    {/* <Route path={parties.children?.[2].path} element={<AddProduct />} /> */}
    <Route path={parties.children?.[2].path} element={<AddEditParty />} />
    <Route path={parties.children?.[3].path} element={<DailyLedgerList />} />
    <Route path={parties.children?.[4].path} element={<AddEditLedgerSlip />} />
    <Route path={parties.children?.[5].path} element={<AddEditLedgerSlip />} />
  </>
);
export const partiesPaths = [parties];
export default PartiesRoutes;
